import type { ParamMatcher } from '@sveltejs/kit';

export const match = ((param: string): param is `${string}.png` => {
	return param.endsWith('.png');
}) satisfies ParamMatcher;
